import script from "./ObjectivesWeightsLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectivesWeightsLoader.vue?vue&type=script&setup=true&lang=js"

import "./ObjectivesWeightsLoader.vue?vue&type=style&index=0&id=334bfe94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334bfe94"]])

export default __exports__